import React from 'react';

import Dialog from 'sharedreact/components/Dialog';

type Props = {
  title: string,
  message?: string,
  language: string,
  info?: string,
  show: boolean,
  zIndex?: number,

  onClose: () => void,
  onClosed?: () => void,
  onConfirm?: () => void
};

class MessageDialog extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { show, zIndex, title, language, message, info, onClose, onClosed, onConfirm } = this.props;

    return (
      <Dialog
        id='ae_dialog_error'
        title={title}
        show={show}
        onClose={onClose}
        onClosed={onClosed}
        zIndex={zIndex || 2000}
        language={language}
        onConfirm={onConfirm}
      >
        <p className='esko_messagedialog_message'>
          {message && message.split('\n').map((item, key) =>
            <span key={key}>{item}<br /></span>
          )}
        </p>
        <p className='esko_messagedialog_info'>
          {info && info.split('\n').map((item, key) =>
            <span key={key}>{item}<br /></span>
          )}
        </p>
      </Dialog>
    );
  }
}

export default MessageDialog;
